module.exports = __webpack_public_path__ + "img/magento-banner_small@2x.ff08b876.webp";